import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import CustomDatePicker from "../../../../../../components/CustomDatePicker/CustomDatePicker";
import styles from './styles.module.css';
import StarRatings from "react-star-ratings";
import VideoModal from "../../../../../../components/VideoModal";
import YOUTUBE_LINKS from "../../../../../../config/youtubeLinks";

export default function Reviews(props) {
    try {
        const {
            reviews,
            startDate,
            setStartDate,
            endDate,
            setEndDate,
            invisParams,
        } = props
        const { t } = useTranslation();
        const history = useHistory();
        const [selectedUsers, setSelectedUsers] = useState(null);
        const [showUsersModal, setShowUsersModal] = useState(false);

        if (!reviews) {
            return (
                <div className={styles.container}>
                    <h1>{t('reviews') || 'Отзывы'}</h1>
                    <div>Загрузка данных отзывов...</div>
                </div>
            )
        }

        const total = Number(reviews?.total_reviews) || 0
        const avg = Number(reviews?.average_rating) || 0

        const asPercent = (num, den) => {
            try {
                if (!den || den === 0) return 0
                const p = Math.max(0, Math.min(100, (num / den) * 100))
                return Math.round(p) || 0
            } catch (e) {
                return 0
            }
        }

        const humanizePeriod = (p) => {
            try {
                const period = (p || '').toString()
                const translations = {
                    '1_week': '1 неделя',
                    '2_weeks': '2 недели', 
                    '1_month': '1 месяц',
                    '3_months': '3 месяца',
                    '6_months': '6 месяцев',
                    '1_year': '1 год'
                }
                return translations[period] || period.replace(/_/g, ' ')
            } catch (e) {
                return ''
            }
        }

        const getDefaultAvatar = () => "https://zumdex.ams3.cdn.digitaloceanspaces.com/public/images/user-default.png"

        const handleUsersClick = (users) => {
            setSelectedUsers(users)
            setShowUsersModal(true)
        }

        const handleUserClick = (userId) => {
            history.push(`/clients/client/${userId}`)
            setShowUsersModal(false)
        }

        const closeModal = () => {
            setShowUsersModal(false)
            setSelectedUsers(null)
        }

        return (
            <div className={styles.container}>
              <div className={styles.containerHead}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  <h2>{t('reviews') || 'Отзывы'}</h2>
                  <VideoModal url={YOUTUBE_LINKS.Reviews} />
                </div>
              </div>

                <h2 className={styles.preTitle}>{t('NSCrossMarketing.choosePeriod') || 'Выберите период'}</h2>

                <div className={styles.dates}>
                    <CustomDatePicker
                        trans={true}
                        tStartDate={startDate}
                        tEndDate={endDate}
                        tSetStartDate={setStartDate}
                        tSetEndDate={setEndDate}
                        startParams={{
                            minDate: new Date((endDate || Date.now()) - 364 * 24 * 60 * 60 * 1000),
                        }}
                        endParams={{
                            minDate: new Date((startDate || Date.now()) + 24 * 60 * 60 * 1000),
                        }}
                    />
                </div>

                <div className={styles.metrics}>
                    <div className={styles.card}>
                        <div className={styles.cardTitle}>{t('Reviews.reviewCount') || 'Количество отзывов'}</div>
                        <div className={styles.bigNumber}>{total}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardTitle}>Средняя оценка</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div className={styles.bigNumber}>{avg.toFixed(1)}</div>
                            <StarRatings
                                rating={avg}
                                numberOfStars={5}
                                starRatedColor="#F5B35C"
                                starEmptyColor="#E7E7E6"
                                name="rating"
                                starSpacing="2px"
                                starDimension="20px"
                            />
                        </div>
                    </div>
                </div>

                {reviews && reviews.rating_breakdown && Array.isArray(reviews.rating_breakdown) && reviews.rating_breakdown.length > 0 && (
                    <div>
                        <div className={styles.sectionTitle}>Распределение оценок</div>
                        <div className={styles.rows}>
                            {reviews.rating_breakdown.map((item, i) => {
                                if (!item) return null
                                return (
                                    <div key={i} className={styles.row}>
                                        <span className={styles.muted}>{t('Reviews.mark') || 'Оценка'} {item.rating || 0}</span>
                                        <div className={styles.barBg}>
                                            <div
                                                className={styles.barFill}
                                                style={{ width: `${asPercent(item.count, total)}%` }}
                                            />
                                        </div>
                                        <span 
                                            className={`${styles.badge} ${item.users?.length > 0 ? styles.clickableBadge : ''}`}
                                            onClick={() => item.users?.length > 0 && handleUsersClick(item.users)}
                                        >
                                            {item?.count || 0} {item.users?.length > 0 && '👥'}
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}

                {reviews && reviews.return_rates && Array.isArray(reviews.return_rates) && reviews.return_rates.length > 0 && (
                    <div>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionTitle} style={{ margin: 0 }}>{t('Reviews.comeBackCount') || 'Возвращаемость клиентов'}</div>
                            <div className={styles.tooltipContainer}>
                                <span className={styles.questionMark}>?</span>
                                <div className={styles.tooltip}>
                                    Эта метрика показывает, сколько клиентов, оставивших отзыв в выбранном периоде, вернулись и совершили повторную покупку.
                                    Например, "1/1" означает, что 1 из 1 клиента вернулся в указанный срок.
                                    Метрика помогает оценить лояльность клиентов после оставления отзыва.
                                </div>
                            </div>
                        </div>
                        <div className={styles.rows}>
                            {reviews.return_rates.map((item, i) => {
                                if (!item) return null
                                return (
                                    <div key={i} className={styles.returnRow}>
                                        <span className={styles.muted}>{humanizePeriod(item.period)}</span>
                                        <div className={styles.barBg}>
                                            <div
                                                className={styles.barFill}
                                                style={{ width: `${asPercent(item.return_rate, 100)}%` }}
                                            />
                                        </div>
                                        <span className={styles.muted}>{item?.users_returned || 0}/{item?.total_users || 0}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}

                {showUsersModal && selectedUsers && (
                    <div className={styles.modalOverlay} onClick={closeModal}>
                        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                            <div className={styles.modalHeader}>
                                <h3>Пользователи</h3>
                                <button className={styles.closeButton} onClick={closeModal}>✕</button>
                            </div>
                            <div className={styles.modalBody}>
                                {selectedUsers.map((user, i) => (
                                    <div 
                                        key={user.id || i} 
                                        className={styles.userCard}
                                        onClick={() => handleUserClick(user.id)}
                                    >
                                        <img 
                                            src={user.avatar || getDefaultAvatar()} 
                                            alt="Avatar"
                                            className={styles.avatar}
                                            onError={(e) => { e.target.src = getDefaultAvatar() }}
                                        />
                                        <div className={styles.userInfo}>
                                            <div className={styles.userName}>
                                                {user.first_name || ''} {user.last_name || ''}
                                            </div>
                                            <div className={styles.userPhone}>
                                                {user.phone || ''}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

            </div>
        )
    } catch (error) {
        console.error('Reviews component error:', error)
        return (
            <div className={styles.container}>
                <h1>{t('reviews') || 'Отзывы'}</h1>
                <div>Ошибка загрузки отзывов. Проверьте консоль.</div>
            </div>
        )
    }
}